import { Chip, ChipProps } from "@mui/material";
import { ConsumablePart } from "utils/robot/consumablePart";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import React from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorIcon from "@mui/icons-material/Error";

type PartsStateChipProps = {
  parts: ConsumablePart[];
};

export const PartsStateChip = ({ parts }: PartsStateChipProps) => {
  const value = getDisplayValue(parts);

  return (
    <Chip
      sx={{ border: "2px solid", fontWeight: "500" }}
      label={value.label}
      color={value.color}
      icon={value.icon}
      variant="outlined"
    />
  );
};

type DisplayValue = {
  label: string;
  color: ChipProps["color"];
  icon: JSX.Element;
};

export const getDisplayValue = (parts: ConsumablePart[]): DisplayValue => {
  const commponProps = { fontSize: "small" as const };
  const hasError = parts.some((p) => p.usage >= p.max);
  if (hasError)
    return {
      label: "要交換",
      color: "error",
      icon: <ErrorIcon {...commponProps} />,
    };
  const hasWarning = parts.some((p) => p.usage > p.max * 0.8);
  if (hasWarning)
    return {
      label: "交換間近",
      color: "warning",
      icon: <WarningAmberIcon {...commponProps} />,
    };
  return {
    label: "OK",
    color: "primary",
    icon: <CheckCircleOutlineIcon {...commponProps} />,
  };
};
